/**
 * Tiles — the 3-up summary tiles at the top of "Mening davomatim" (S6).
 *
 * Hours arrive PRE-FORMATTED from the backend ('8s 45m', '11 kun') — render
 * each value verbatim, never re-format.
 *
 * Props:
 *   items  [{ value, label }]  — usually 3 (week / month / workdays)
 *   live?  { hm } | null       — optional "Hozir ishda · <hm>" live line under
 *                                the tiles when the worker is mid-shift
 */
import { T } from '../lib/i18n.js';

export default function Tiles({ items = [], live = null }) {
  return (
    <>
      <div className="tiles">
        {items.map((it, i) => (
          <div className="tile" key={i}>
            <div className="v">{it.value}</div>
            <div className="k">{it.label}</div>
          </div>
        ))}
      </div>
      {live ? (
        <div className="liveline">
          <span className="pulse" />
          {T.live_now} · {live.hm}
        </div>
      ) : null}
    </>
  );
}
